/*
 * Presentational only. `my-cork-box.js` owns the tray's numbers; it writes "0",
 * "0 lb" and "$0.00" into an empty tray. The catalogue design never shows a
 * column of zeros, so this mirrors the count onto a `data-empty` flag and lets
 * CSS swap in the empty treatment. No cart or packing state is touched.
 */
(function () {
  'use strict';

  var trays = document.querySelectorAll('[data-plate-tray]');
  if (!trays.length || typeof MutationObserver !== 'function') return;

  trays.forEach(function (tray) {
    var counter = tray.querySelector('[data-simple-box-count]');
    if (!counter) return;

    var box = tray.querySelector('[data-plate-tray-box]');

    function sync() {
      var empty = (parseInt(counter.textContent, 10) || 0) === 0;
      tray.setAttribute('data-empty', String(empty));
      if (box) box.setAttribute('data-empty', String(empty));
    }

    new MutationObserver(sync).observe(counter, {
      childList: true,
      characterData: true,
      subtree: true
    });

    sync();
  });

  // The shared mobile box affordance is intentionally hidden beside the desktop
  // tray. Once Shopify confirms a real add, bridge that existing event into the
  // visible 3D box so the accepted piece still has a clear destination.
  document.addEventListener('corkopia:piece-added', function (event) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var target = Array.prototype.find.call(document.querySelectorAll('[data-plate-tray-box]'), function (box) {
      var bounds = box.getBoundingClientRect();
      return bounds.width > 0 && bounds.height > 0;
    });
    if (!target) return;

    var variantId = String(event.detail && event.detail.variantId || '');
    var sourceButton = Array.prototype.find.call(document.querySelectorAll('[data-cork-add]'), function (button) {
      return String(button.dataset.variantId || '') === variantId;
    });
    var source = sourceButton && sourceButton.closest('[data-cork-product-card], [data-quick-view-dialog], .pl-card');
    var image = source && source.querySelector('.pl-card__frame img, .cork-product-card__image--primary, [data-quick-view-image], img');
    if (!image) return;

    var from = image.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var flyer = image.cloneNode(false);
    flyer.className = 'pl-preview-flyer';
    flyer.setAttribute('aria-hidden', 'true');
    Object.assign(flyer.style, {
      left: from.left + from.width / 2 - 28 + 'px',
      top: from.top + from.height / 2 - 35 + 'px'
    });
    document.body.appendChild(flyer);
    target.classList.add('is-receiving');

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height * 0.42 - (from.top + from.height / 2);
    var animation = flyer.animate([
      { transform: 'translate3d(0,0,0) rotate(0deg) scale(1)', opacity: 1 },
      { transform: 'translate3d(' + (dx * 0.36) + 'px,' + (dy * 0.2 - 60) + 'px,4rem) rotate(-7deg) scale(.9)', opacity: 1, offset: .4 },
      { transform: 'translate3d(' + (dx * 0.74) + 'px,' + (dy * 0.6 - 42) + 'px,2rem) rotate(7deg) scale(.62)', opacity: .95, offset: .74 },
      { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) rotate(13deg) scale(.28)', opacity: .08 }
    ], { duration: 880, easing: 'cubic-bezier(.2,.72,.2,1)', fill: 'forwards' });

    animation.finished.catch(function () {}).finally(function () {
      flyer.remove();
      target.classList.remove('is-receiving');
    });
  });
})();
